(() => {
  if (window.MCForBrands) return

  const connectedSliders = new WeakSet()

  const connectSlider = (sliderElement) => {
    if (connectedSliders.has(sliderElement)) return

    let attempts = 0

    const waitForSwiper = () => {
      const slider = sliderElement.slider
      const navigation = sliderElement.querySelector('[data-mc-for-brands-navigation]')

      if (!slider) {
        attempts += 1
        if (attempts < 120) window.requestAnimationFrame(waitForSwiper)
        return
      }

      connectedSliders.add(sliderElement)

      const syncNavigation = () => {
        if (!navigation) return

        navigation.classList.toggle('d-none', slider.isLocked)
        navigation.classList.toggle('d-flex', !slider.isLocked)
      }

      ;['lock', 'unlock', 'resize', 'breakpoint', 'update', 'slidesLengthChange'].forEach((eventName) => {
        slider.on(eventName, syncNavigation)
      })

      slider.update()
      syncNavigation()
    }

    waitForSwiper()
  }

  const connectSliders = (container = document) => {
    if (container.matches?.('[data-mc-for-brands-slider]')) connectSlider(container)
    container.querySelectorAll?.('[data-mc-for-brands-slider]').forEach(connectSlider)
  }

  connectSliders()

  document.addEventListener('shopify:section:load', (event) => {
    connectSliders(event.target)
  })

  document.addEventListener('click', (event) => {
    const sliderButton = event.target.closest('[data-mc-for-brands-prev], [data-mc-for-brands-next]')

    if (sliderButton) {
      const sliderElement = sliderButton.closest('[data-mc-for-brands-slider]')
      if (!sliderElement?.slider) return

      if (sliderButton.hasAttribute('data-mc-for-brands-prev')) {
        sliderElement.slider.slidePrev()
      } else {
        sliderElement.slider.slideNext()
      }
      return
    }

    const anchor = event.target.closest('[data-mc-for-brands-anchor]')
    if (!anchor) return

    const href = anchor.getAttribute('href')
    if (!href?.startsWith('#')) return

    const target = document.querySelector(href)
    if (!target) return

    event.preventDefault()
    target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  })

  window.MCForBrands = { connectSliders }
})()
